import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import errorToast from '../../components/toasts/errorToast';
import { documentsDelete, documentSummary, documentsView, translateSummary } from '../../redux/actions/documentAction';
import SkeletonParagraph from '../../components/loaders/Loader';
import TranslatedDocFileViewer from '../../components/viewers/docs-viewer';
import { IoArrowBack } from 'react-icons/io5';
import { availableLanguages } from '../../components/data/languageData';
import moment from 'moment';
import { marked } from "marked";
import ExportDocx from '../../components/button/exsportDocFile';
import CustomButton from '../../components/button/button';
import DeleteConfirmModal from '../../components/modals/confirmation/delete-confirmation-modal';
import successToast from '../../components/toasts/successToast';
import { getLangName } from '../../components/helper'
import { useAuth } from '../../context/AuthContext';;

const ViewDocument = () => {
    const { id } = useParams()
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const [documentData, setDocumentData] = useState()
    const [loading, setLoading] = useState(false); // Don't load initially
    const [targetLanguage, setTargetLanguage] = useState('')
    const [summaryData, setSummaryData] = useState('');
    const [translatedSummaryData, setTranslatedSummaryData] = useState('')
    const [showSummary, setShowSummary] = useState(false);
    const [prompt, setPrompt] = useState('');
    const [showDeleteModal, setshowDeleteModal] = useState(false);
    const { isAdmin } = useAuth();

    const onSuccess = (data) => {
        setDocumentData(data?.data?.data);
        // setLoading(false);
    };
    const onError = (data) => {
        errorToast(data?.data?.message);
        setLoading(false);
    };

    useEffect(() => {
        if (id) {
            dispatch(documentsView({ id }, onSuccess, onError));
        }
    }, [id, dispatch]);

    const handleDelete = (id) => {
        dispatch(documentsDelete({ id }, onDeleteSuccess, onError));
    };

    const onDeleteSuccess = (data) => {
        successToast(data?.data?.message);
        navigate(-1);
    }

    const onSummuryClick = () => {
        setLoading(true);
        setShowSummary(true);
        dispatch(documentSummary({ id: id, prompt: prompt }, (data) => { setSummaryData(marked(data.data.data)); setLoading(false); }, onError))
    }

    const onTranslateClick = () => {
        setLoading(true);
        dispatch(translateSummary({ id: id, targetLanguage, text: summaryData }, (data) => { setTranslatedSummaryData(marked(data.data.data)); setLoading(false); setTargetLanguage('') }, onError))
    }

    return (
        <div className='h-100 overflow-auto'>
            <div className="w-100 d-flex gap-1 align-items-center header border-bottom position-sticky top-0 bg-white py-2 justify-content-between">
                <div className='d-flex'>
                    <span className="px-1 fs_16 cursor_pointer" onClick={() => navigate(-1)}><IoArrowBack /></span>
                    <h2 className="fs_20 fw_400 fn_Roboto text-start px-2 pt-1">View Document</h2>
                </div>
                {isAdmin &&
                    <div className='d-flex'>
                        <CustomButton className='cursor_pointer fs_18 pb-1 mx-1 d-flex align-items-center justify-content-center text-nowrap'
                            variant='danger' onClick={() => { setshowDeleteModal(true) }}>
                            Delete Document
                        </CustomButton>
                        {!documentData?.is_published && <CustomButton
                            className={`fs_18 fw_400 fn_Roboto mx-1 cursor_pointer`}
                            style={{ height: '35px', width: '140px' }} variant='primary'
                            onClick={() => {
                                navigate('/assign-teams', { state: { selectedItems: [id] } });
                            }}
                        >
                            Assign To Team
                        </CustomButton>}
                    </div>
                }
            </div>

            <div className="text-start p-3 d-flex flex-column w-100 gap-3 overflow-auto">
                <div className='d-flex gap-2 flex-wrap'>
                    <div className="mb-2 ">
                        <label className="pb-1" >Document Name</label> <br />
                        <input type='text' style={{ width: "20rem" }} value={documentData?.name ?? "Loading..."} disabled className='input-field' />
                    </div>
                    <div className="mb-2 ">
                        <label className="pb-1" >Source Language</label> <br />
                        <input type='text' style={{ width: "20rem" }} value={getLangName(documentData?.source_lang) ?? "Loading..."} disabled className='input-field' />
                    </div>
                    <div className="mb-2 ">
                        <label className="pb-1" >Upload By</label> <br />
                        <input type='text' style={{ width: "20rem" }} value={documentData?.uploadedUser?.email ?? "Loading..."} disabled className='input-field' />
                    </div>

                    <div className="mb-2 ">
                        <label className="pb-1" >Status</label> <br />
                        <input type='text' style={{ width: "20rem" }} value={documentData?.status ?? "Loading..."} disabled className='input-field' />
                    </div>
                    <div className="mb-2 ">
                        <label className="pb-1" >No of Pages </label> <br />
                        <input type='text' style={{ width: "20rem" }} value={documentData?.no_of_pages ?? "Loading..."} disabled className='input-field' />
                    </div>
                    <div className="mb-2 ">
                        <label className="pb-1" >Description </label> <br />
                        <input title={documentData?.comments} style={{ width: "20rem" }} value={documentData?.comments ?? "Loading..."} disabled className='input-field' />
                    </div>
                    <div className="table-responsive overflow-auto" style={{ minWidth: '61rem' }}>
                        <table className="table table-bordered">
                            <thead className="table-light">
                                <tr className="text-start text-nowrap">
                                    <th width={'30%'} className='fw_400'>Assigned Translation Team</th>
                                    <th width={'30%'} className='fw_400'>Target Date</th>
                                    <th width={'30%'} className='fw_400'>Target Language</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="3">Loading...</td>
                                    </tr>
                                ) : documentData?.assignedTeams?.length > 0 ? (
                                    documentData.assignedTeams.map((item, index) => (
                                        <tr key={index}>
                                            <td className='fs_14 text-muted'>
                                                {item?.team?.name}
                                            </td>
                                            <td className='fs_14 text-muted'>
                                                {moment(item?.target_date).format('MM/DD/YY, hh:mm A')}
                                            </td>
                                            <td className='fs_14 text-muted'>
                                                {item?.target_lang?.map((lang) => `${getLangName(lang)} (${lang})`).join(", ")}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3">No rows to display</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>


                    <div className='d-flex gap-2 align-items-end'>
                        <textarea type='text' placeholder='Describe how would you like to get your summary ' style={{ width: "40.5rem" }} rows={3} value={prompt} onChange={(e) => setPrompt(e.target.value)} className='input-field' />
                        <Button variant="primary" className='' onClick={onSummuryClick} style={{ height: '35px', width: '130px' }}>
                            Get Summary
                        </Button>
                    </div>
                </div>
                <div className={`d-flex flex-column flex-md-row gap-4`}>
                    <div className='w-100 mt-3' style={{ border: '1px solid gray', borderRadius: '4px', height: '40.5rem' }}>
                        {documentData?.name?.endsWith('.pdf') || documentData?.name?.endsWith('.html') ? (
                            <iframe title="File Preview" src={documentData?.signedUrl} className="w-100 h-100" />
                        ) : (
                            <TranslatedDocFileViewer fileUrl={documentData?.signedUrl} className="w-100 h-100" />
                        )}
                    </div>

                    {showSummary && (
                        <div className="w-100">
                            <div className='d-flex align-items-center justify-content-evenly my-1'>
                                <span>Document Summary</span>
                                <div className='d-flex gap-1'>
                                    <div className="text-start gap-3 mb-2 text-nowrap mx-4 pt-1">
                                        <select
                                            id="target_lang"
                                            name="target_lang"
                                            className="input-field"
                                            style={{ width: '12rem' }}
                                            onChange={(e) => setTargetLanguage(e.target.value)}
                                        >
                                            <option value="">Select Target Language</option>
                                            {availableLanguages.map((language) => (
                                                <option key={language.value} value={language.value}>
                                                    {language.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <Button variant="primary" className='' onClick={onTranslateClick} style={{ height: '40px' }} disabled={!targetLanguage}>
                                        Translate
                                    </Button>
                                    {/* <ExportPDF text={summaryData} fileName={documentData?.name?.split('.').slice(0, -1).join('.')} /> */}
                                    <ExportDocx text={translatedSummaryData || summaryData} />
                                </div>
                            </div>
                            <div className="w-100 p-2 overflow-auto" style={{ border: '1px solid gray', borderRadius: '4px', height: '38rem' }}>
                                {loading ? <SkeletonParagraph lines={10} /> : <div dangerouslySetInnerHTML={{ __html: translatedSummaryData ? translatedSummaryData : summaryData }} />}
                            </div>
                        </div>
                    )}
                </div>



            </div>
            <DeleteConfirmModal
                isOpen={showDeleteModal}
                onClose={() => setshowDeleteModal(false)}
                deletConfirmationMsg={`Are you sure you want to delete ${documentData?.name} document and all its related data?`}
                type={"Document"}
                onDelete={handleDelete}
                id={id}
            />
        </div>

    )
}

export default ViewDocument